<div class="modal-content">
  <!-- Header -->
  <div class="modal-header">
    Playbook Settings
    <i class="material-icons" data-bs-dismiss="modal" (click)='closeModal()'>close</i>
  </div>
  <!-- Body -->
  <div class="modal-body">
    <form name="cssForm">
      <div class="column-wrapper">
        <!-- Custom Fonts toggle button -->
        <div class="row align-items-center form-group">
          <label class="col-sm-3 control-label" style="margin-top: 7px;">Custom Fonts</label>
          <div class="col-sm-9">
            <div class="btn-group btn__sm">
              <label class="switch">
                <input type="checkbox" [checked]="playbook.enableCustomFonts"
                  (change)="playbook.enableCustomFonts = !playbook.enableCustomFonts">
                <span class="slider vPlaybookActiveToggle round"></span>
              </label>
            </div>
          </div>
        </div>
        @if (playbook.enableCustomFonts) {
          <!-- Is Embedded toggle button and Link textarea -->
          <div class="row align-items-center form-group">
            <label class="col-sm-3 control-label">IsEmbeded?</label>
            <div class="col-sm-9">
              <div class="btn-group btn__sm">
                <label class="switch">
                  <input type="checkbox" [checked]="playbook.isEmbededFonts"
                    (change)="playbook.isEmbededFonts = !playbook.isEmbededFonts">
                  <span class="slider vPlaybookActiveToggle round"></span>
                </label>
              </div>
            </div>
          </div>
          <div class="offset-sm-3 col-sm-9" style="padding-left: 8px; padding-right: 0px;">
            @if (playbook.enableCustomFonts) {
              <textarea placeholder="{{(playbook.isEmbededFonts ?'Paste font face here':'Paste the link here')}}"
                class="css-textarea" id="customFonts" name="customFonts" [(ngModel)]="playbook.customFonts" cols="74"
              rows="5" style="margin-bottom: 20px;"></textarea>
            }
          </div>
        }
        <div class="row form-group">
          <!-- Custom CSS textarea -->
          <label for="CSS" class="col-sm-3 control-label pt-0">Custom CSS</label>
          <div class="col-sm-9">
            <textarea class="css-textarea" placeholder="body { }" id="CSS" name="customCss"
              [(ngModel)]="playbook.customCss" cols="74" rows="13"
            (ngModelChange)="setplaybookCustomCss($event)"></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!-- Footer -->
  <div class="modal-footer">
    <button type="button" class="btn vPlaybookDefaultButton btn__btn-default" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn__btn-default btn__orange" (click)="savePlaybookCss()">Save</button>
  </div>
</div>
